<div class="flex">
  <div
    class="flex text-[13px] font-semibold text-[#203D54] mt-[10px] w-[8.4rem] items-center"
  >
    Grade
  </div>
  <div class="autocomplete-container">
    <div class="w-[100%] flex justify-start mb-[5px] ml-[8px]">
      <div class="flex justify-start">
        <div
          class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
        >
          <img
            src="assets/icons/close.svg"
            alt="close"
            class="cursor-pointer w-[14px]"
            (click)="cancel()"
          />
        </div>
        <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
          <img
            src="assets/icons/save.svg"
            alt="save"
            class="cursor-pointer w-[20px] pr-[2px]"
            (click)="save()"
          />
        </div>
      </div>
    </div>
    <input
      #inputGradeField
      matInput
      placeholder="Select Grade"
      [formControl]="gradeControl"
      (focus)="onFocus()"
      (blur)="onBlur()"
      class="input-field"
    />

    <div class="dropdown" *ngIf="showDropdown">
      <ng-container style="width: 279px !important">
        <div *ngIf="grades?.length > 0">
          <div
            *ngFor="let grade of grades"
            (click)="onSelectionChange(grade)"
            class="dropdown-item"
          >
            {{ grade?.name }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div class="flex items-center mb-[18px]" *ngIf="selectedGradeName === 'Custom'">
  <label
    for="customGrade"
    class="section-label-sm font-semibold text-[#203D54] w-[6.5rem]"
    >Custom Grade
  </label>
  <input
    type="text"
    id="customGrade"
    formControlName="customGrade"
    class="input-field"
    placeholder="Enter Custom Grade"
  />
</div>
